import { getCalcPriceImage } from '@/components/Cloud/Atoms/Image/ImagePrice/ImagePrice.service';
import { currencyFormatPtBr } from '../../../../../../../services/currencyFormat.service';
import { UHCSidebarServerContractProps } from '../../../../../Molecules/Server/Contract/Sidebar/Sidebar.interface';
import { Image } from '@/components/Cloud/Cloud.model';

function calcPriceHardware(
    hardware: UHCSidebarServerContractProps['profileSelected']['hardware'],
    applyDiscount: boolean): number {

    const bandwidthPrice = calcPriceIncluded(hardware.bandwidth);
    const diskPrice = calcPriceIncluded(hardware.disk);

    const computePrice = applyDiscount ? hardware.memory.prices.discount.price : hardware.memory.prices.price

    const totalPrice = bandwidthPrice + diskPrice + computePrice
    
    return totalPrice
}

function calcPriceHardwareImage(
    priceHardware: number,
    priceImage: number,
    vcpu: UHCSidebarServerContractProps['profileSelected']['hardware']['memory']['vcpu'],
    isChargeTypeFlat:boolean) {

    return (isChargeTypeFlat)?priceHardware + priceImage : priceHardware + (priceImage * vcpu)
}

function priceFormatPTBR(value: number) {
    return currencyFormatPtBr(value);
}

function getMinPrice(price: number, minAvailable: number) {
    const minValue = minAvailable
    return price * minValue
}

function calcPriceIncluded(
    currentProfile: UHCSidebarServerContractProps['profileSelected']['hardware']['bandwidth']
        | UHCSidebarServerContractProps['profileSelected']['hardware']['disk']) {

    const valIncluded = currentProfile.sizeIncluded;
    const priceIncludes = getMinPrice(currentProfile.price, valIncluded);

    if (valIncluded === currentProfile.size) return 0

    const result = (currentProfile.size * currentProfile.price) - priceIncludes
    return result
}

export function calcPriceImageHardwareFormated(
    hardware: UHCSidebarServerContractProps['profileSelected']['hardware'],
    image: UHCSidebarServerContractProps['profileSelected']['image'],
    applyDiscount: boolean
) {

    const isChargeTypeFlat = (image.application && image.application.price && image.application.price.chargeType === 'FLAT')
    const totalPriceImage = getCalcPriceImage(image);
    const totalPiceHardware = calcPriceHardware(hardware, applyDiscount);
    const totalPrice = calcPriceHardwareImage(totalPiceHardware, totalPriceImage, hardware.memory.vcpu, isChargeTypeFlat);


    return priceFormatPTBR(totalPrice);
}